document.addEventListener('DOMContentLoaded',()=>{
    // 회원가입 고객 리디렉션
    if (sessionStorage.getItem('justRegistered') === 'true') {
        sessionStorage.removeItem('justRegistered');
        // 로그인된 상태면  리디렉션
        if (customerLogIn) {
            window.location.href = '/a/customerhub#account:a:dashboard';
        }
    }
})
